import $ from "jquery";

class Client {

    constructor() {
        this.form = "#clientForm";

        this.bindSubmitForm();
    }

    bindSubmitForm() {
        $(document).ready(() => {

            $(document).on("submit", "#clientForm", () => {

                const password = $(this.form).find('#password').val();
                const button = $(this.form).find('.button');

                button.addClass('button--loading').prop('disabled', true);

                $.post('/client', {
                    password
                })
                    .then((response) => {
                        const body = response;

                        if (body !== "[logged]") {
                            $(this.form).find('.error').removeClass("hidden");
                        } else {

                            const date = new Date();
                            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
                            document.cookie = `client=no; path=/; expires=${date.toGMTString()}`;

                            window.location.reload();
                        }

                        button.removeClass('button--loading').prop('disabled', false);
                    });

                return false;
            });

        });
    }
}

export default new Client();
